import React from "react";

import {
  Box,
  Flex,
  Heading,
  Link,
  LinkButton,
  Span,
  Text,
} from "@catchoftheday/cg-components";

import { OnePassHeader } from "@header/components/OnePassHeader";

export const PopupContent: React.FC = () => {
  return (
    <Flex
      width="400px"
      flexDirection="column"
      color="typography.text"
      boxShadow="0 2px 4px 0 rgba(0,0,0,0.50)"
      bg="white"
      borderRadius="16px"
      overflow="hidden"
      fontFamily="onePass"
    >
      <OnePassHeader pb="20px">
        <Heading.h3
          fontFamily="inherit"
          fontWeight="bold"
          m="0px"
          mb="10px"
          color="inherit"
        >
          Deals, meet points
        </Heading.h3>
        <Text m="0" textAlign="center" fontSize="xs" fontWeight="medium">
          Collect 2 flybuys points per $2 spent with Catch*
        </Text>
      </OnePassHeader>
      <Box pb="20px" px="14px">
        <Flex
          mt="10px"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <LinkButton
            block={false}
            fontWeight="semibold"
            sizeVariant="md"
            variant="onePassPrimary"
            href="/rewards/flybuys/link"
            data-tracking="header-app-onepass-link-flybuys"
          >
            LINK flybuys
          </LinkButton>
        </Flex>
        <Flex my="16px" alignItems="center" justifyContent="center">
          <Span fontSize="xs" fontWeight="bold" color="onePass.primary">
            <Link
              color="inherit"
              href="/flybuys-catch"
              data-tracking="header-app-flybuys-learn-more"
              textDecoration="underline"
            >
              Learn more
            </Link>
          </Span>
        </Flex>
        <Flex alignItems="center" justifyContent="center">
          <Span fontSize="xs" fontWeight="medium" color="textTertiary">
            *Term, conditions and exclusions apply.
          </Span>
        </Flex>
      </Box>
    </Flex>
  );
};
